module.exports = __webpack_public_path__ + "images/emoji/repeat_one.2825a5265300e4421ff7.png";